import { type ReactElement } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useAuth } from "../providers/auth-provider";

/** Route layout that redirects to `/login` when the user is not signed in.
 * Renders a minimal loader while the auth session is hydrating on first
 * paint so we don't flash the login screen over a valid session.
 *
 * The `from` state is preserved so `/login` can redirect back after sign-in. */
export function RequireAuth(): ReactElement {
  const { session, initializing, sessionExpired } = useAuth();
  const location = useLocation();

  if (initializing) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-bg-app text-sm text-text-tertiary"
        data-testid="auth-loading"
      >
        Sitzung wird geprüft…
      </div>
    );
  }

  if (!session) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname + location.search,
          ...(sessionExpired && { reason: "expired" }),
        }}
      />
    );
  }

  return <Outlet />;
}
